import React, { memo } from 'react';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { Content } from '../../../infrastructure/content';

const TechnicalErrorPage = memo(function TechnicalErrorPage() {
  return (
    <Content>
      {({ technicalErrorHeader, technicalErrorLead, technicalErrorPara }) => (
        <StandardBody>
          <PageHeading>{technicalErrorHeader}</PageHeading>
          <p>{technicalErrorLead}</p>
          <p>{technicalErrorPara}</p>
        </StandardBody>
      )}
    </Content>
  );
});

export default TechnicalErrorPage;
